module.exports = __webpack_public_path__ + "img/组 2246@2x.75cb0c36.png";